/*
 * MDB shim for toast
 * Files currently importing this symbol from "mdbreact":
 * - src/App.jsx
 * - src/Component/Dialog/DialogAddNote.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Accounts/accountList.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activities-list.jsx
 * - src/Seating/Activities/activitiesModal.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/inventoryTracking.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/Filters/UserFilters.jsx
 * - src/Seating/InventoryProduct/inventoryProductTable.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/RecurringOrders.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/createNoteModal.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Patient/pqQuoteSelector.jsx
 * - src/Seating/PurchaseQueue/PODeliveryUpdate.jsx
 * - src/Seating/PurchaseQueue/inventoryRequest.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Reports/approvalReport.jsx
 * - src/Seating/Reports/complaintReport.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/addDeliveryAcknowledgement.jsx
 * - src/Seating/Settings/addProdcutMatrixEntry.jsx
 * - src/Seating/Settings/addProductSubType.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 * - src/Seating/Settings/trainingLink.jsx
 * - src/Seating/Settings/vendor.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import { enqueueSnackbar } from "notistack";

const variantByLevel = {
  default: "default",
  success: "success",
  error: "error",
  warning: "warning",
};

const snackbarVariants = new Set([
  "default",
  "success",
  "error",
  "warning",
  "info",
]);

function normalizeMessage(message) {
  if (message instanceof Error) {
    return message.message || null;
  }

  if (typeof message === "string") {
    return message;
  }

  if (
    typeof message === "number" ||
    typeof message === "bigint" ||
    typeof message === "boolean"
  ) {
    return String(message);
  }

  if (message && typeof message.message === "string") {
    return message.message || null;
  }

  return null;
}

function getSnackbarOptions(level, options) {
  const snackbarOptions = {
    variant: variantByLevel[level] || "default",
  };

  if (!options || typeof options !== "object") {
    return snackbarOptions;
  }

  if (snackbarVariants.has(options.variant)) {
    snackbarOptions.variant = options.variant;
  }

  if (options.autoClose === false) {
    snackbarOptions.persist = true;
  } else if (
    typeof options.autoClose === "number" &&
    Number.isFinite(options.autoClose) &&
    options.autoClose >= 0
  ) {
    snackbarOptions.autoHideDuration = options.autoClose;
  }

  if (typeof options.persist === "boolean") {
    snackbarOptions.persist = options.persist;
  }

  if (typeof options.preventDuplicate === "boolean") {
    snackbarOptions.preventDuplicate = options.preventDuplicate;
  }

  return snackbarOptions;
}

function emit(level, message, options = {}) {
  try {
    const normalizedMessage = normalizeMessage(message);

    if (normalizedMessage === null) {
      return;
    }

    enqueueSnackbar(normalizedMessage, getSnackbarOptions(level, options));
  } catch {
    // Notifications are non-critical and must never break their caller.
  }
}

function toast(message, options) {
  emit("default", message, options);
}

toast.success = (message, options) => emit("success", message, options);
toast.error = (message, options) => emit("error", message, options);
toast.warn = (message, options) => emit("warning", message, options);
toast.warning = toast.warn;
toast.danger = toast.error;

export default toast;
